<script lang="ts">
  import { ReviewModel } from '@centerhealth/fe/center-kit';
  import { ReviewCard } from '@centerhealth/fe/center-kit';
  export let reviews: ReviewModel[] = [];
  import { fade } from 'svelte/transition';
</script>

<div class="container mx-auto pt-9 xxl:pt-10">
  <div class="xl:px-8 xxl:px-10">
    <h1 class="mb-4 text-2xl text-center leading-tight xl:text-3xl text-gray-darkest">
      Join a growing community improving their blood sugar with Center! 🌎
    </h1>
    <p class="mb-5 leading-tight text-center text-gray text-lg mt-2 xl:text-xl">
      Read what real customers are saying about our convenience, pricing, accuracy and more ⬇️
    </p>
  </div>
  <div class="inline-block gap-0 masonry">
    {#each reviews as review, i}
      <div in:fade|local={{ delay: i * 10, duration: 200 }}>
        <ReviewCard {...review} />
      </div>
    {/each}
  </div>
</div>

<style lang="postcss">
  /** Tablets **/
  @screen md {
    .masonry {
      column-count: 2;
    }
  }

  /** Large **/
  @screen lg {
    .masonry {
      column-count: 3;
    }
  }
</style>
